import { APIInterfaceI, buildRequest, PaginationT } from '.';

class sources implements APIInterfaceI {
  getAll = (pagination: PaginationT) => (
    buildRequest('GET', `/sources?cursor=${pagination.cursor}&limit=${pagination.limit}`)
  )

  getOne = (targetId: string) => (
    buildRequest('GET', `/sources/${targetId}`)
  )

  getUrl = (type: string) => (
    buildRequest('GET', `/generate-url?source=${type}`)
  )

  register = (formData: any) => (
    buildRequest('POST', '/sources', formData)
  )

  update = (targetId: string, formData: any) => (
    buildRequest('PUT', `/sources/${targetId}`, formData)
  )

  delete = (targetId: string) => (
    buildRequest('DELETE', `/sources/${targetId}`)
  )

  getAvailablesSourceNames = () => (
    buildRequest('GET', '/system/sources')
  )
}

export default sources;
